/**  Статус завки кредита. */
export enum CreditRequestStates {
  // На рассмотрении.
  UnderConsideration = 0,

  // Одобрена.
  Approved = 1,

  // Отказана.
  Canceled = 2,

  // Подготовка документов.
  DocsPreparing = 3,

  // Докумены готовы.
  DocsPrepared = 4,

  // Ожидание выдачи.
  AwaitToIssued = 5,

  // Требуется обращение в офис.
  NeedToOffice = 6
}
